// if ( typeof AnnouncementBar !== 'function' ) {

//   class AnnouncementBar extends HTMLElement {

//     constructor() {

//       super();

//       this.slider = this.querySelector('[data-js-slider]');
//       this.content = this.querySelectorAll('.announcement');
//       this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
//       this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

//       this.index = 0;
//       this.length = this.content.length;
      
//       if ( this.nextButton ) {
//         this.nextButton.addEventListener('click', ()=>{
//           this.changeSlide('next');
//         });
//       }
//       if ( this.prevButton ) {
//         this.prevButton.addEventListener('click', ()=>{
//           this.changeSlide('prev');
//         });
//       }
      
//     }

//     changeSlide(direction) {

//       this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
//       this.prevButton.classList.remove('announcement-bar__content-nav--disabled')
 
//       if ( direction == 'next' ) {
//         this.index++;
//       } else if ( direction == 'prev' ) {
//         this.index--;
//       }

//       if ( this.index == this.length - 1 ) {
//         this.nextButton.classList.add('announcement-bar__content-nav--disabled')
//       } else if ( this.index == 0 ) {
//         this.prevButton.classList.add('announcement-bar__content-nav--disabled')
//       }

//       this.slider.scrollTo({
//         top: 0,
//         left: this.content[this.index].offsetLeft,
//         behavior: 'smooth'
//       });

//     }

//   }

//   if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
//     customElements.define('announcement-bar', AnnouncementBar);
// 	}

// }

if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      /* SETTINGS FROM THEME */
      this.autoScrollEnabled = this.dataset.autoScroll === 'true';
      this.scrollSpeed = parseInt(this.dataset.scrollSpeed) * 1000 || 4000;

      this.autoScrollInterval = null;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
          this.restartAutoScroll();
        });
      }

      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
          this.restartAutoScroll();
        });
      }

      /* START AUTO SCROLL ONLY IF ENABLED */
      if ( this.autoScrollEnabled ) {
        this.startAutoScroll();
      }
    }

    startAutoScroll() {
      if ( this.length <= 1 ) return;

      this.autoScrollInterval = setInterval(() => {
        if ( this.index >= this.length - 1 ) {
          this.index = -1;
        }
        this.changeSlide('next');
      }, this.scrollSpeed);
    }

    restartAutoScroll() {
      if ( !this.autoScrollEnabled ) return;

      clearInterval(this.autoScrollInterval);
      this.startAutoScroll();
    }

    changeSlide(direction) {
      if ( this.nextButton && this.prevButton ) {
        this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
        this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
      }

      if ( direction === 'next' ) {
        this.index++;
      } else if ( direction === 'prev' ) {
        this.index--;
      }

      if ( this.index >= this.length ) this.index = 0;
      if ( this.index < 0 ) this.index = this.length - 1;

      if ( this.slider && this.content[this.index] ) {
        this.slider.scrollTo({
          top: 0,
          left: this.content[this.index].offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
